//pagination prams
export const PAGE_RANGE = 2;

//api endpoints
export const LOGIN_URL = "/auth/login";
export const SIGNUP_URL = "/auth/signup";
export const GET_USER_URL = "/user/getUser";
export const VERIFY_OTP_URL = "/auth/verifyOtp";
export const RESEND_OTP_URL = "/auth/resendOtp";
export const EDIT_PROFILE_URL = "/user/updateUser";
export const RESET_PASSWORD_URL = "/auth/resetPassword";
export const DELETE_ACCOUNT_URL = "/user/deleteAccount";
export const CHANGE_PASSWORD_URL = "/user/changePassword";
export const FORGOT_PASSWORD_URL = "/auth/forgotPassword";
export const BUYER_GET_WISHLIST = "/wishlist/getWishlist";
export const SELLER_GET_WISHLIST = "/wishlist/getWishlist";
export const ADMIN_GET_ALL_USERS_URL = "/user/getAllUsers";
export const BUYER_ADD_NDC_URL = "wishlist/addBuyerWishlist";
export const SELLER_ADD_NDC_URL = "wishlist/addSellerWishlist";
export const Delete_Adopter = `/AddEditSubscriptionModalAdopter/`;
export const ADMIN_CHANGE_USER_STATUS_URL = "/user/changeUserStatus";
export const FOLLOW_UP_SURVEY_URL = "/adopter/surveyoptions";
export const SURVEY_URL = "/adopter/survey";

export const Single_Adopter_User_List = `/adopter/getSingleAdopter/`;
export const ADD_PHARMACY_DETAIL_URL = "/pharmacy/addPharmacyDetails";
// admin api endpoint
export const SHELTER_LIMIT_PUT = "/shelter/shelterLimit";
export const GET_ALL_SHELTERS = "/shelter/getAllShelter";
export const UPDATE_SHELTERS = "/admin/updateShelterByAdmin/:id";
export const DASHBOARD_CARDS = "/dashboard/dashboardCard";
export const SHELTER_LIMIT_GET = "/shelter/getAllShelterLimit";
export const ADMIN_GET_LATEST_SHELTERS = "/admin/latestShelters";
export const GENERATE_QR_CODES_API_URL = "/shelter/numberDownload";
export const ADMIN_DASHBOARD_GRAPH = "/adopter/getAllAdopterGraph";
export const UPDATE_SHELTER_EMAIL = "/admin/updateShelterByAdmin/";
export const GET_ADOPTERS_OF_SHELTER = "/admin/getAllAdopterByAdmin/";
export const GET_SHELTERS_NAMES_BY_ADMIN = "/admin/getAllShelterByAdmin";
export const ADMIN_ARCHIVE_SHELTER = "/admin/archiveShelter";
export const ADMIN_UNARCHIVE_SHELTER = "/admin/unarchiveShelter";
export const ADMIN_DELETE_SHELTER_PERMANENTLY =
  "/admin/deleteShelterPermanently";
export const ADMIN_GET_ARCHIVED_SHELTERS = "/admin/archivedShelters";

//options
export const NumberOfCats = [
  ...(() => {
    const options = [];

    for (let i = 1; i <= 291; i += 10) {
      const end = i + 9 <= 300 ? i + 9 : 300;
      options.push({
        label: `${i} - ${end} cats`,
        value: [i, end],
      });
    }
    options.push({ label: "300+ Cats", value: "300+ Cats" });
    options.push({ label: "Don't know yet", value: "Don't know yet" });

    return options;
  })(),
];

export const STATE_ABBREVIATIONS = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

export const US_States = [
  ...(() => {
    const options = [];

    const states = [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ];
    states.forEach((state) => {
      options.push({
        label: state,
        value: state,
      });
    });

    return options;
  })(),
];

export const shippingMethodOptions = [
  { label: "Shipping method", value: "parsal" },
  { label: "Shipping method 1", value: "physically" },
  { label: "Shipping method 2", value: "online" },
];

export const yearsData = [
  { label: "2024", value: "2024" },
  { label: "2023", value: "2023" },
  { label: "2022", value: "2022" },
  { label: "2021", value: "2021" },
  { label: "2020", value: "2020" },
  { label: "2019", value: "2019" },
  { label: "2018", value: "2018" },
  { label: "2017", value: "2017" },
  { label: "2016", value: "2016" },
  { label: "2015", value: "2015" },
];
export const productSubscription = [
  { label: "MULTI CAT", value: "42662009471125" },
  { label: "HEALTHY CAT", value: "42661956550805" },
  { label: "UNSCENTED", value: "42662019858581" },
  { label: "WOOD PELLETS", value: "45119920930965" },
];

export const FrequencyOptions = [
  {
    label: "Days",
    value: "day",
  },
  {
    label: "Weeks",
    value: "week",
  },
  {
    label: "Months",
    value: "month",
  },
];

export const DaysOptions = [
  ...(() => {
    const options = [];
    for (let i = 5; i <= 90; i += 5) {
      options.push({
        label: `${i} days`,
        value: i,
      });
    }
    return options;
  })(),
];

export const WeeksOptions = [
  ...(() => {
    const options = [];
    options.push({
      label: "1 week",
      value: 1,
    });
    for (let i = 2; i <= 12; i++) {
      options.push({
        label: `${i} weeks`,
        value: i,
      });
    }
    return options;
  })(),
];

export const MonthsOptions = [
  ...(() => {
    const options = [];
    options.push({
      label: "1 month",
      value: 1,
    });
    for (let i = 2; i <= 12; i++) {
      options.push({
        label: `${i} months`,
        value: i,
      });
    }
    return options;
  })(),
];

export const RecordsPerPageOptions = [
  {
    label: "10 records",
    value: "10",
  },
  {
    label: "20 records",
    value: "20",
  },
  {
    label: "30 records",
    value: "30",
  },
  {
    label: "40 records",
    value: "40",
  },
  {
    label: "50 records",
    value: "50",
  },
];

// +++++++++++  Column of Recent 5 Shelters Data table   ++++++++++++

export const columnsForRecent5Shelters = [
  { label: "Shelter Name", dataKey: "shelterName", align: "left" },
  { label: "Email", dataKey: "email", align: "left" },
  { label: "State", dataKey: "state", align: "center" },
  { label: "Invites sent", dataKey: "totalAdopters", align: "center" },
  { label: "Redemptions", dataKey: "redeem", align: "center" },
  { label: "Ratio", dataKey: "ratio", align: "center" },
  { label: "Status", dataKey: "status", align: "center" },
  { label: "Action", dataKey: "action", align: "center" },
];

// +++++++++++  Column of Recent 5 orders Data table   ++++++++++++

export const columnsForRecent5Orders = [
  { label: "Product ID", dataKey: "productId", align: "center" },
  { label: "Product Name", dataKey: "productName", align: "center" },
  { label: "Order Number", dataKey: "orderNumber", align: "center" },
  { label: "Quantity", dataKey: "quantity", align: "center" },
  { label: "Country", dataKey: "country", align: "center" },
  { label: "State", dataKey: "state", align: "center" },
  { label: "Order Date", dataKey: "lastSentDate", align: "center" },
  { label: "Customer Name", dataKey: "shelterName", align: "center" },
  { label: "Customer ID", dataKey: "customerId", align: "center" },
];

export const survayOptionsUuids = [
  "4f3e5851-8124-49fc-97d8-54b85cffd7af",
  "63944ac9-8003-414f-b902-fda546a6c467",
  "6bdc13a8-b2b0-429a-ae5a-c0f8ee0f3eb7",
  "a12bfa47-c0a7-4235-8187-8556ca54300c",
  "b55922f3-b8cf-45fe-9694-117423873fc2",
  "ee115747-2ce1-466f-a89a-a6e021eb8deb",
  "ff266792-1919-4129-8954-f3e593784f34",
];
